import { css, SerializedStyles } from '@emotion/react';
import { IconButtonTheme } from '../../types';

export const ICON_BUTTON_DEFAULT_THEME: IconButtonTheme = {
    colors: {
        primary: {
            hoverBg: 'grey.base',
            icon: 'text.body',
        },
        secondary: {
            hoverBg: 'grey.base',
            icon: 'text.heading',
        },
        tertiary: {
            hoverBg: 'grey.base',
            icon: 'grey.base',
        },
    },
};

export const ICON_BUTTON_GLOBAL_VARIABLES: SerializedStyles = css`
    :root {
        --ib-size-2xs: 16px;
        --ib-size-xs: 24px;
        --ib-size-s: 32px;
        --ib-size-m: 36px;
        --ib-size-l: 40px;

        --ib-radius-2xs: 4px;
        --ib-radius-xs: 6px;
        --ib-radius-s: 8px;
        --ib-radius-m: 10px;
        --ib-radius-l: 12px;

        --ib-icon-size-2xs: 12px;
        --ib-icon-size-xs: 16px;
        --ib-icon-size-s: 22px;
        --ib-icon-size-m: 24px;
        --ib-icon-size-l: 28px;

        --ib-size: var(--ib-size-m);
        --ib-radius: var(--ib-radius-m);
        --ib-icon-size: var(--ib-icon-size-m);
        --ib-icon-color: var(--hc-color-primary-base);

        --ib-color-neutral-hover-bg: var(--hc-color-grey-base);
        --ib-color-neutral-icon: var(--hc-color-grey-base);
        --ib-color-black-hover-bg: var(--hc-color-grey-base);
        --ib-color-black-icon: var(--hc-color-common-black);
        --ib-color-white-hover-bg: var(--hc-color-common-white);
        --ib-color-white-icon: var(--hc-color-common-white);

        --ib-hover-opacity: 0.1;
        --ib-filled-background: var(--hc-color-common-white);

        --ib-edge-adjustment: calc((var(--ib-size) - var(--ib-icon-size)) / 2);
    }
`;
